import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1b4d3ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
    imageUrl: {},
    userName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.imageUrl,
          referrerpolicy: "no-referrer",
          alt: "user avatar",
          class: "avatar__image",
          width: "26",
          height: "26"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.userName?.charAt(0) || 'a'), 1))
  ]))
}
}

})